import React from "react";
import {
  Grid,
  Typography,
  Box,
  Link,
  Button,
  useTheme,
} from "@material-ui/core";
import { PhotoUploaderStyles } from "./PhotoUploaderStyles";
import { getPhoneNumberForOpco, getPrettyPhoneNumber } from "../util/Utilities";
import { loadedThemeIdentifier } from "../withRoot";
import { goToClaimsBtn } from "../constants/GlobalConstants";

const performGoToClaim = async () => {
  window.parent.postMessage(
    { messageName: "POST_FNOL_GO_TO_CLAIM", claimNumber: "NA" },
    "*",
  );
};

export const ErrorPage: React.FC = () => {
  const classes = PhotoUploaderStyles();
  const theme = useTheme();
  const contactPhoneNumber = getPrettyPhoneNumber(
    getPhoneNumberForOpco(loadedThemeIdentifier),
  );
  const handleCallUs = () => {
    if (contactPhoneNumber) {
      window.open("tel:+" + contactPhoneNumber, "_blank");
    } else {
      console.error("Invalid phone number");
    }
  };

  return (
    <div>
      <Grid container style={{ marginTop: "1rem" }}>
        <Grid item xs={12}>
          <Typography
            className={classes.landpageHeader}
            style={{ margin: "1rem" }}
          >
            <div className={classes.vehInfoDetails}>
              <span
                className="icon-alert"
                style={{ color: "#8A0200", margin: "1rem" }}
              ></span>
              We’re having trouble uploading photos
            </div>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          className={classes.nextStepDesc}
          style={{ margin: "1rem" }}
        >
          <Typography className={classes.nextStepDesc}>
            To upload photos, try again in a few minutes or contact us for
            assistance.
          </Typography>
          <br />
          <Button
            className={classes.btnColor}
            style={{
              height: theme.custom.styles.uploadButton.height || "50px",
            }}
            color="primary"
            variant="contained"
            onClick={performGoToClaim}
          >
            {goToClaimsBtn}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default ErrorPage;
